// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3377e363","455":"493348d4","977":"5f81be4b"}[chunkId] + ".chunk.js";
};